import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function ZoomInIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 40 40"
  }, props, {
    contextType: contextType,
    className: `pi pi-zoom-in-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.2 34.07l-8.61-8.61c1.63-2.57 2.57-5.61 2.57-8.88C33.17 7.43 25.74 0 16.58 0 7.42 0 0 7.43 0 16.59s7.42 16.58 16.58 16.58c3.27 0 6.32-.95 8.88-2.58l8.61 8.6c1.19 1.19 3.27 1.04 4.65-.34l.13-.13c1.39-1.38 1.54-3.46.35-4.65zM3 16.59C3 9.08 9.08 3 16.58 3s13.58 6.08 13.58 13.58-6.08 13.58-13.58 13.58S3 24.09 3 16.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.86 14.62h-4.31v-4.31c0-.42-.34-.75-.75-.75h-2.43c-.42 0-.75.34-.75.75v4.31H10.3c-.42 0-.75.34-.75.75v2.43c0 .42.34.75.75.75h4.31v4.31c0 .42.34.75.75.75h2.43c.42 0 .75-.34.75-.75v-4.31h4.31c.42 0 .75-.34.75-.75v-2.43c.02-.42-.32-.75-.74-.75z"
  })));
}